import BicepsCurlGIF from './BicepsCurl.gif';
import BandKickbackGIF from './BandKickback.gif';
import LyingTricepExtensionGIF from './LyingTricepExtension.gif';
import BackExtensionsGIF from './BackExtensions.gif';

const GIF = {
  BicepsCurl: BicepsCurlGIF,
  BandKickback: BandKickbackGIF,
  LyingTricepExtension: LyingTricepExtensionGIF,
  BackExtensions: BackExtensionsGIF,
};

export { GIF };
